import { sendRequestsDelegation } from "./sendRequestsDelegation.thunk.action";

import { $api } from "../../../../../services/request.config";

export const validateRequestsDelegation = ({
                                               modalWindowKP,
                                               setModalWindowKP,
                                               delegationState, setIsLoading, setModalSuccess, setNotification,
                                           }) => async(dispatch) => {
    try {
        console.log({
            modalWindowKP,
            setModalWindowKP,
            delegationState,

        });
        const response = await $api.post("/v1/manager/delegations/validations", delegationState);
        console.log(response);
        if(response.status === 200) {
            if (response.data.length > 0) {
                let blockingArray = response.data.map((element, index) => {
                    let temp;
                    if (element.validationFailures && element.validationFailures.length) {
                        temp = element.validationFailures.filter((requests, indexRequests) => (
                            requests.isBlocking === true
                        ));
                        temp = temp.map((el, index) => {
                            return { ...el, code: index, block: 1,
                                message:` ${index === 0 ? element.applicationName + ". " : "" }  ${el.message}` };
                        });
                        // console.log(temp);

                    }
                    // element.details && element.details.length && element.details.filter((worker, indexWorker) => (
                    //     worker.isBlocking === true
                    // ));
                    return { ...element, isSuccess: false, details: temp };
                });
                 blockingArray = blockingArray.filter(requests => requests.validationFailures.length > 0);
                setModalWindowKP(
                    blockingArray
                )
                }
            } else if(response.status ===204) {
            dispatch(sendRequestsDelegation(delegationState, setIsLoading, setModalSuccess, setNotification));

        }

        // const data = [
        //     {
        //         "applicationName": "Привлечение к работе в выходные и праздничные дни",
        //         "validationFailures": [
        //             {
        //                 "isBlocking": true,
        //                 "message": "Ошибка: в период делегирования планируются изменения в вашем назначении",
        //                 "checkDescription": "Проверка, что делегирующий не переводится на другую ЯШР в период действия делегирования",
        //             },
        //         ],
        //     },
        //
        // ];
    } catch (e) {

    }
}
